var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { importJWK, CompactEncrypt } from "jose";
import KeysService from "./services/KeysService";
import { DCF_PARAM_NOT_VALID, SrciDcfWrapper } from "../helpers/SrciDcfWrapper";
import { validateCardDetails, validateSrciInitParams, validateEnrollCardParams, recognizeCardBrand as recognizeCardBrandAlias, isCardNumberValid as isCardNumberValidAlias, isPanExpirationDateInFuture as isPanExpirationDateInFutureAlias, isCardSecurityCodeValid as isCardSecurityCodeValidAlias, validateIdentityLookupParams, isCardExpirationDateValid, isEmailValid, } from "../helpers/Validators";
import PayairBackendService from "./services/PayairBackendService";
import { DcfSdkEnumsObj } from "../models/DcfSdkEnum";
import { detect } from "detect-browser";
import supportedBrowsers from "../supportedBrowsers";
/** @internal */
var MASTERCARD_SANDBOX_URL = "https://sandbox.src.mastercard.com/sdk/srcsdk.mastercard.js";
var MASTERCARD_PRODUCTION_URL = "https://src.mastercard.com/sdk/srcsdk.mastercard.js";
var VISA_SANDBOX_URL = "https://sandbox-assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visaSdk.js?v2";
var VISA_PRODUCTION_URL = "https://assets.secure.checkout.visa.com/checkout-widget/resources/js/src-i-adapter/visaSdk.js?v2";
/** @internal */
var payairBackendService;
var sdkInitialized = new Map([
    [DcfSdkEnumsObj.MASTERCARD, false],
    [DcfSdkEnumsObj.VISA, false],
]);
/** @internal */
var isVisaDpaTransactionOptions = function (dcfSdk, dpaTransactionOptions) { return dcfSdk === DcfSdkEnumsObj.VISA; };
/** @internal */
var SrciLogicSdkImpl = /** @class */ (function () {
    function SrciLogicSdkImpl() {
        var _this = this;
        this.init = function (srciLogicSdkInitParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () {
            var dpaTransactionOptions, dcfInitParams;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateSrciInitParams(srciLogicSdkInitParams);
                        if (!payairBackendService) {
                            payairBackendService = new PayairBackendService(srciLogicSdkInitParams.pspName);
                        }
                        dpaTransactionOptions = srciLogicSdkInitParams.dpaTransactionOptions;
                        if (isVisaDpaTransactionOptions(dcfSdk, dpaTransactionOptions)) {
                            dpaTransactionOptions = __assign(__assign({}, dpaTransactionOptions), { customInputData: __assign(__assign({}, dpaTransactionOptions.customInputData), { checkoutOrchestrator: "merchant" }) });
                        }
                        dcfInitParams = {
                            srcInitiatorId: srciLogicSdkInitParams.srcInitiatorId,
                            srciDpaId: srciLogicSdkInitParams.srciDpaId,
                            srciTransactionId: srciLogicSdkInitParams.srciTransactionId,
                            dpaTransactionOptions: dpaTransactionOptions,
                            dpaData: srciLogicSdkInitParams.dpaData,
                        };
                        return [4 /*yield*/, addDcfScript(dcfSdk, srciLogicSdkInitParams.environment).then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (response !== true) {
                                                return [2 /*return*/, Promise.resolve(response)];
                                            }
                                            return [4 /*yield*/, SrciDcfWrapper("init", dcfSdk, dcfInitParams)];
                                        case 1:
                                            _a.sent();
                                            sdkInitialized.set(dcfSdk, true);
                                            return [2 /*return*/, Promise.resolve(true)];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.enrollCard = function (enrollCardParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateEnrollCardParams(enrollCardParams);
                        return [4 /*yield*/, SrciDcfWrapper("enrollCard", dcfSdk, enrollCardParams)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.checkout = function (checkoutParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SrciDcfWrapper("checkout", dcfSdk, checkoutParams)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.checkoutWithNewCard = function (checkoutParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SrciDcfWrapper("checkoutWithNewCard", dcfSdk, checkoutParams)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.getSrcProfile = function (getSrcProfileParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SrciDcfWrapper("getSrcProfile", dcfSdk, getSrcProfileParams)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.encryptCard = function (cardDetails, dcfSdk, environment, pspName) { return __awaiter(_this, void 0, void 0, function () {
            var keysService, fpanEncryptionJwk, _a, publicKey, cardDetailsJson, binaryCardDetailsJson, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 9, , 10]);
                        keysService = new KeysService(environment, pspName);
                        validateCardDetails(cardDetails);
                        fpanEncryptionJwk = void 0;
                        _a = dcfSdk;
                        switch (_a) {
                            case DcfSdkEnumsObj.VISA: return [3 /*break*/, 1];
                            case DcfSdkEnumsObj.MASTERCARD: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, keysService.getVisaFpanEncryptionJwk()];
                    case 2:
                        fpanEncryptionJwk = _b.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, keysService.getMastercardFpanEncryptionJwk()];
                    case 4:
                        fpanEncryptionJwk = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        {
                            throw new Error(DCF_PARAM_NOT_VALID);
                        }
                        _b.label = 6;
                    case 6:
                        if (!fpanEncryptionJwk) {
                            throw new Error("Error on fetching fpanEncryptionJwk");
                        }
                        return [4 /*yield*/, importJWK(fpanEncryptionJwk)];
                    case 7:
                        publicKey = _b.sent();
                        cardDetailsJson = JSON.stringify(cardDetails);
                        binaryCardDetailsJson = new TextEncoder().encode(cardDetailsJson);
                        return [4 /*yield*/, new CompactEncrypt(new Uint8Array(binaryCardDetailsJson))
                                .setProtectedHeader({
                                alg: fpanEncryptionJwk.alg,
                                enc: "A256GCM",
                                kid: fpanEncryptionJwk.kid,
                                typ: "JOSE",
                                iat: Date.now(),
                            })
                                .encrypt(publicKey)];
                    case 8: return [2 /*return*/, _b.sent()];
                    case 9:
                        error_1 = _b.sent();
                        console.error("".concat(dcfSdk, " encryptCard error"), error_1.message);
                        return [2 /*return*/, null];
                    case 10: return [2 /*return*/];
                }
            });
        }); };
        this.identityLookup = function (identityLookupParams, dcfSdk) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validateIdentityLookupParams(identityLookupParams);
                        return [4 /*yield*/, SrciDcfWrapper("identityLookup", dcfSdk, identityLookupParams)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.checkoutTransaction = function (srciCheckoutRequest) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!payairBackendService) {
                            throw new Error("SDK_NOT_INITIALIZED");
                        }
                        return [4 /*yield*/, payairBackendService.checkoutTransaction(srciCheckoutRequest)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.initiateIdentityValidation = function (validationChannelId, dcfSdk) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SrciDcfWrapper("initiateIdentityValidation", dcfSdk, { requestedValidationChannelId: validationChannelId })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.completeIdentityValidation = function (validationData, dcfSdk) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, SrciDcfWrapper("completeIdentityValidation", dcfSdk, { validationData: validationData })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); };
        this.unbindAppInstance = function (idTokens, dcfSdk) { return __awaiter(_this, void 0, void 0, function () {
            var token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(idTokens && idTokens.length)) return [3 /*break*/, 2];
                        token = void 0;
                        switch (dcfSdk) {
                            case DcfSdkEnumsObj.VISA:
                                token = idTokens[0];
                                break;
                            default:
                                token = idTokens;
                                break;
                        }
                        return [4 /*yield*/, SrciDcfWrapper("unbindAppInstance", dcfSdk, { idToken: token })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, SrciDcfWrapper("unbindAppInstance", dcfSdk)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.isBrowserSupported = function () {
            var browserInfo = detect();
            var detectedBrowser = browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.name;
            if (!detectedBrowser) {
                return false;
            }
            return supportedBrowsers.includes(detectedBrowser);
        };
        this.isSdkInitialized = function (dcfSdk) { return isSdkInitializedImpl(dcfSdk); };
        this.isEmailValid = function (email) { return isEmailValid(email); };
    }
    SrciLogicSdkImpl.prototype.isRecognized = function (paramsOrDcfSdk, dcfSdk) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof paramsOrDcfSdk === "string" || paramsOrDcfSdk === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, SrciDcfWrapper("isRecognized", paramsOrDcfSdk)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, SrciDcfWrapper("isRecognized", dcfSdk, paramsOrDcfSdk)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SrciLogicSdkImpl.prototype.recognizeCardBrand = function (cardNumber) {
        return recognizeCardBrandAlias(cardNumber);
    };
    SrciLogicSdkImpl.prototype.isCardNumberValid = function (cardNumber, cardBrand) {
        return isCardNumberValidAlias(cardNumber, cardBrand);
    };
    SrciLogicSdkImpl.prototype.isPanExpirationDateInFuture = function (panExpirationYear, panExpirationMonth) {
        return isPanExpirationDateInFutureAlias(panExpirationYear, panExpirationMonth);
    };
    SrciLogicSdkImpl.prototype.isCardExpirationDateValid = function (panExpirationYear, panExpirationMonth) {
        return isCardExpirationDateValid(panExpirationYear, panExpirationMonth);
    };
    SrciLogicSdkImpl.prototype.isCardSecurityCodeValid = function (cvv) {
        return isCardSecurityCodeValidAlias(cvv);
    };
    return SrciLogicSdkImpl;
}());
export { SrciLogicSdkImpl };
/** @internal */
export var addDcfScript = function (dcfSdk, environment) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = dcfSdk;
                switch (_a) {
                    case DcfSdkEnumsObj.MASTERCARD: return [3 /*break*/, 1];
                    case DcfSdkEnumsObj.VISA: return [3 /*break*/, 3];
                }
                return [3 /*break*/, 5];
            case 1: return [4 /*yield*/, addMastercardScript(environment)];
            case 2: return [2 /*return*/, _b.sent()];
            case 3: return [4 /*yield*/, addVisaScript(environment)];
            case 4: return [2 /*return*/, _b.sent()];
            case 5:
                {
                    throw new Error(DCF_PARAM_NOT_VALID);
                }
                _b.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
/** @internal */
export var addMastercardScript = function (environment) { return __awaiter(void 0, void 0, void 0, function () {
    var mastercardSdkScript;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                mastercardSdkScript = environment === "QA" ? MASTERCARD_SANDBOX_URL : MASTERCARD_PRODUCTION_URL;
                return [4 /*yield*/, addScript(mastercardSdkScript).then(function (response) {
                        //if add script returned true, check if object exists
                        if (response === true && window.SRCSDK_MASTERCARD) {
                            return true;
                        }
                        return false;
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/** @internal */
export var addVisaScript = function (environment) { return __awaiter(void 0, void 0, void 0, function () {
    var visaSdkScipt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                visaSdkScipt = environment === "QA" ? VISA_SANDBOX_URL : VISA_PRODUCTION_URL;
                return [4 /*yield*/, addScript(visaSdkScipt).then(function (response) {
                        //if add script returned true, check if object exists
                        if (response === true && window.vAdapters) {
                            var vSrcAdapter = window.vAdapters.VisaSRCI;
                            window.SRCSDK_VISA = new vSrcAdapter();
                            return true;
                        }
                        return false;
                    })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/** @internal */
export var isSdkInitializedImpl = function (dcfSdk) {
    var isMastercardInitialized = sdkInitialized.get(DcfSdkEnumsObj.MASTERCARD) === true && window.SRCSDK_MASTERCARD !== undefined;
    var isVisaInitialized = sdkInitialized.get(DcfSdkEnumsObj.VISA) === true && window.SRCSDK_VISA !== undefined;
    switch (dcfSdk) {
        case DcfSdkEnumsObj.MASTERCARD: {
            return isMastercardInitialized;
        }
        case DcfSdkEnumsObj.VISA: {
            return isVisaInitialized;
        }
        default: {
            return isMastercardInitialized && isVisaInitialized;
        }
    }
};
/** @internal */
export var addScript = function (scriptUrl) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve) { return __awaiter(void 0, void 0, void 0, function () {
                var isScriptAdded, intervalId_1, script;
                return __generator(this, function (_a) {
                    isScriptAdded = !!Array.from(window.document.getElementsByTagName("script")).find(function (element) { return element.src === scriptUrl; });
                    if (isScriptAdded) {
                        intervalId_1 = setInterval(function () {
                            if (window[scriptUrl] === true || window[scriptUrl] === false) {
                                clearInterval(intervalId_1);
                                resolve(true);
                            }
                        }, 100);
                    }
                    else {
                        script = window.document.createElement("script");
                        script.src = scriptUrl;
                        script.async = true;
                        script.onload = function () {
                            //indicate that script is properly loaded
                            window[scriptUrl] = true;
                            resolve(true);
                        };
                        script.onerror = function () {
                            //indicate script load error
                            window[scriptUrl] = false;
                            resolve(false);
                        };
                        //clear place for script load indicator
                        window[scriptUrl] = null;
                        window.document.head.appendChild(script);
                    }
                    return [2 /*return*/];
                });
            }); })];
    });
}); };
